export default "__VITE_ASSET__C$wcvuaH__"